import leftArrow from '../../../../../assets/images/layout/left-arrow.svg';
import {useI18n} from '../../../../common/providers/I18nProvider';

interface Props {
	show: boolean;
	title: string;
	action: () => void;
}

export default function BackButtonBar({show, title, action}: Props) {
	const {i18n} = useI18n();

	if (!show) return null;

	return (
		<div className='text-center relative py-4 border-b-2'>
			<span className='absolute left-[5%] top-[30%]'>
				<button onClick={action}>
					<img src={leftArrow} alt='' />
				</button>
			</span>

			<span className='text-sm font-bold'>{i18n(title)}</span>
		</div>
	);
}
